import { Link } from '@tanstack/react-router';
import { CloudDownload } from 'lucide-react';

import { Button } from '~/components/ui/button';

/**
 * Full-page empty state shown inside the `/experiments/create` flow when the
 * tenant's aggregate `catalogImportStatus` is not `COMPLETE`. Mirrors the
 * shape of `ConnectChannelPlaceholder` (one layer up the gate stack) so the
 * two empty states feel like the same surface.
 */
export function CatalogImportRequiredPlaceholder() {
  return (
    <div className="bg-gradient-page flex h-full min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <CloudDownload className="text-muted-foreground h-12 w-12" aria-hidden="true" />
      <div className="space-y-1.5">
        <h1 className="text-2xl font-semibold tracking-tight">Catalog import not complete</h1>
        <p className="text-muted-foreground max-w-md text-sm">
          Finish onboarding to start creating experiments — your catalog import isn't complete yet.
        </p>
      </div>
      <Button asChild className="cursor-pointer">
        <Link to="/onboarding/paid-ads">Continue onboarding</Link>
      </Button>
    </div>
  );
}
